<template>
  <Row class-name="c-select-title">
    <Col :span="24">
      <Button type="default" icon="md-add" :disabled="disabled" @click="$emit('on-append')">创意标题</Button>
      <span style="padding: 0 8px">已选：{{ titleLen }}/{{ max }}</span>
      <Button type="primary" style="margin-left: 20px" :disabled="disabled" @click="docModel = true">选择文案</Button>
    </Col>
    <Col :span="24">
      <m-caption
        v-for="(item, idx) in value"
        v-model="item.title"
        :key="idx"
        :index="idx"
        :min-len="1"
        :max-len="60"
        :words="words"
        :del="titleLen > 1"
        @on-delete="$emit('on-delete', idx)"
      />
    </Col>

    <document v-model="docModel" :open-id="openId" @on-select="appendDocument" @on-cancel="docModel = false" />
  </Row>
</template>
<script>
import MCaption from '@/components/caption.vue'
import Document from '@/views/create/toutiao_local/components/idea/document/document.vue'
export default {
  name: 'SelectTit',
  components: { MCaption, Document },
  props: {
    value: {
      type: Array,
      required: true
    },
    max: {
      type: Number
    },
    words: {
      type: Array,
      default() {
        return []
      }
    },
    openId: {
      type: [String, Number]
    }
  },
  computed: {
    titleLen() {
      return this.value.length
    },
    disabled() {
      return this.titleLen >= this.max
    }
  },
  data() {
    return {
      docModel: null
    }
  },
  methods: {
    appendDocument(docs) {
      const len = this.max - this.titleLen
      if (docs.length > len) {
        const idx = docs.length - len
        docs.splice(-idx, idx)
      }
      docs.forEach((ret) => {
        this.$emit('on-append', ret)
      })
      this.docModel = false
    }
  }
}
</script>
<style lang="scss" scoped>
.c-select-title {
  position: relative;

  .c-caption-body {
    margin-top: 30px;
  }
}
</style>
